import React from 'react';
import StyleCard from '../../../components/StyleSelector/StyleCard';

export default function StyleOptions({ selectedStyles, onStyleSelect, onModalOpen, validationErrors }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <StyleCard
        title="Book Style"
        subtitle={selectedStyles?.bookStyle?.title}
        image={selectedStyles?.bookStyle?.image}
        onClick={() => onModalOpen('book')}
        selected={!!selectedStyles?.bookStyle}
        error={validationErrors?.bookStyle}
      />
      
      <StyleCard
        title="Visual Style"
        subtitle={selectedStyles?.visualStyle?.title}
        image={selectedStyles?.visualStyle?.image}
        onClick={() => onModalOpen('visual')}
        selected={!!selectedStyles?.visualStyle}
        error={validationErrors?.visualStyle}
      />
      
      <StyleCard
        title="Writing Style"
        subtitle={selectedStyles?.writingStyle?.title}
        image={selectedStyles?.writingStyle?.image}
        onClick={() => onModalOpen('writing')}
        selected={!!selectedStyles?.writingStyle}
        error={validationErrors?.writingStyle}
      />
    </div>
  );
}